import React, { useState, useEffect } from "react";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import { ActualizarClasificador } from "./modalAgregarClass";
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";
const headCells = [
  {
    id: "",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "DESCRIPCIÓN",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "ID",
    width: "40px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaClasepp(props) {
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [publicidad, setPublicidad] = useState();
  const [operacion, setOperacion] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idtipopublicidad.includes(target.value) ||
              x.codigoordenanza
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "tipopublicidad";
    let orden = "idtipopublicidad";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarRegistro = (idtipopublicidad) => {
    let campos = "*";
    let nomtab = "tipopublicidad";
    let nomid = "idtipopublicidad";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idtipopublicidad}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtipopublicidad > 0) {
            setPublicidad(response.data);
            setMostrar5(true);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setPublicidad();
  };
  const consultarPP = (ope, id) => (event) => {
    event.preventDefault();
    blanquear();
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else if (ope === 4) {
      setOperacion(4);
      seleccionarRegistro(id);
    } else if (ope === 2) {
      setOperacion(2);
      seleccionarRegistro(id);
    } else if (ope === 3) {
      setOperacion(3);
      seleccionarRegistro(id);
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };
  useEffect(() => {
    seleccionarRegistros();
  }, []);
  const cerrar = () => {
    props.setTabla(0);
  };
  return (
    <div className="col-8 m-0 p-2 border rounded">
          <header className="col-12 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant">
              <h3 className="fw-bold m-0">Gestion de Registro Clasificador de Publicidad</h3>
              <a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
                Salir <i className="fas fa-times ms-2"></i>
              </a>
          </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
            <div className="col-4 m-0 p-0">
            <SearchInput
                className="form-control form-control-sm mr-sm-2 rounded-pill"
                style={{ border: "1px solid #007bff" }}
                type="search"
                placeholder="Buscar"
                onChange={handleSearch}
                aria-label="Search"
            />
            </div>
            <div className="col-auto m-0 p-0">
            <PrimaryButton icon = 'fa-plus m-0'
                onClick={consultarPP(1, "", "")}
            />
            </div>
        </div>
        <div className="col-12 m-0 p-0">
        <TblContainer>
            <TblHead />

            <tbody>
            {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                <tr
                    key={item.idtipopublicidad}
                    style={{ padding: "0" }}
                >
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10px",
                    }}
                    >
                    {item.codigoordenanza}
                    </td>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "200px",
                    }}
                    >
                    {item.descripcion}
                    </td>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "40px",
                    }}
                    >
                    {item.idtipopublicidad}
                    </td>
                    <td
                    align="center"
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "80px",
                    }}
                    >
                    <button
                        onClick={consultarPP(4, item.idtipopublicidad)}
                        className="btn btn-info btn-sm rounded-circle"
                    >
                        <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                        onClick={consultarPP(2, item.idtipopublicidad)}
                        className="btn  btn-warning btn-sm rounded-circle"
                    >
                        <i className="fas fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                        onClick={consultarPP(3, item.idtipopublicidad)}
                        className="btn  btn-danger btn-sm rounded-circle"
                    >
                        <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
        </TblContainer>
        <TblPagination />
        </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <ActualizarClasificador
        show={mostrar5}
        publicidad={publicidad}
        onHideRenderizar={seleccionarRegistros}
        onHideCancela={cerrarModalActualizar}
        operacion={operacion}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaClasepp;
